
import React, { useState, useEffect } from "react";
import {ORG_DSC_CERTIFICATE_DELETE,ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER,ORG_DSC_CERTIFICATES_FLITER_LIST,ORG_DELETE_TO_DO_ITEM ,ORG_TODO_LIST_ADDONS} from '../../../../../ApiServices/BaseURL';
import { getData, postData } from "../../../../../ApiServices/ApiService";
import { useLocation } from 'react-router-dom';
import { useTheme } from "../../../../../GlobalContext/GlobalContext";

const ToDoListActiveController = (onRefresh,activeToDoList,setActiveToDoLoading,setActiveToDoError,setActiveToDoList,showFilter) => {

    const location = useLocation();
    const { source, status } = location?.state || {};
    const { setIsLoginPopup } = useTheme();
    const [currentPage, setCurrentPage] = useState(1);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const[addedDate, setAddedDate] = useState('');
    const[dueDate, setDueDate] = useState('');

    const itemsPerPage = 10;

    const totalPages = Math.ceil(activeToDoList?.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentToDoActiveItems = activeToDoList?.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const handleDelete = (activeTodo, index) => {
        console.log("active ToDo",activeTodo )
        setSelectedDocument({ activeTodo, index });
        setIsDeleteModalOpen(true);
      };
    
      const handleOpenDeleteModal = () => {
        setIsDeleteModalOpen(true); // Open the modal
      };
    
      const handleCloseDeleteModal = () => {
        setIsDeleteModalOpen(false); // Close the modal
      };

      const [loading,setLoading] = useState(false);
  const [activeToDoDeleteError, setActiveToDoDeleteError] = useState('');
  const [success, setSuccess] = useState('');
  const [currentActiveToDoDeleteIndex, setCurrentActiveToDoDeleteIndex] = useState(null);
  const [deletedMessages, setDeletedMessages] = useState([]);

  const handleToDoActiveItemDelete = async () => {
   
    try {
      const { activeTodo, index } = selectedDocument;
      setCurrentActiveToDoDeleteIndex(null)
      setActiveToDoDeleteError('');  
        setSuccess('')      
        setLoading(true);
        setCurrentActiveToDoDeleteIndex(index)
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        const payLoad = {  emp_id_auth: storedUserInfo?.emp_id, "sc_id": activeTodo?.sc_id}
    
        //console.log('handleSearchEmployee payload',payLoad);
        // Make the API call
        const response = await postData(ORG_DELETE_TO_DO_ITEM,payLoad);
        const responseData = await response.json();
        //console.log('response Data',responseData);
    
        // Check for success (200) and internal status code
        if (response?.status === 200) {
          if (responseData?.statusCode === 200) {
            if (responseData?.message.toLowerCase() === 'success') {
                setActiveToDoDeleteError('');
              setDeletedMessages((prevDeleted) => [...prevDeleted, activeTodo.dsc_id]);
                setSuccess(responseData?.info);
                setTimeout(()=>{
                  setSuccess('');
                  onRefresh();
                },3000);
                // setEmployeeList(responseData?.dataJ || []);
            } else {
                setActiveToDoDeleteError(responseData?.info || 'Failed to delete notice board message. Please try again.');
            }
          } else {
            setActiveToDoDeleteError(responseData?.info || 'Failed to delete notice board message. Status code error.');
          }
        } 
        // Token-related errors: 400, 401, 403
        else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
          if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
            setActiveToDoDeleteError('Unauthorized access. Your session may have expired. Please log in again.');
            // Optionally, redirect to the login page or refresh the token
            // Example: redirectToLogin();
          } else {
            setActiveToDoDeleteError(responseData?.info || 'Bad request. Please check the request parameters.');
          }
        } 
        // Internal Server Error: 500
        else if (response?.status === 500) {
            setActiveToDoDeleteError(responseData?.info || 'Internal Server Error. Please try again later.');
        } 
        // Unexpected or network-related errors
        else {
            setActiveToDoDeleteError('Unexpected error occurred. Please try again later.');
        }
      } catch (error) {
        // Handle various error scenarios
        if (error.response) {
          // Server responded with a status outside the 2xx range
          setActiveToDoDeleteError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to delete notice board message. Please try again.'}`);
        } else if (error.request) {
          // Request was made but no response was received
          setActiveToDoDeleteError('No response received from the server. Please check your network connection and try again.');
        } else {
          // An error occurred in setting up the request
          setActiveToDoDeleteError(`Failed to delete notice board message. Please check your network connection and try again.`);
        }
      } finally {
        setLoading(false);
        // setCurrentNoticeDeleteIndex(null)
      }

    // onValueChange(teamData);
    // onClose();
};

const [searchUser, setSearchUser] = useState('');
const [error, setError] = useState('');
const [employeeList, setEmployeeList] = useState([]);
const [clientSearchError, setClientSearchError] = useState('');
const [employeesListLoading, setEmployeeListLoading] = useState(false)
    const handleSearchEmployee = async () => {

        try {
            setError('');
            setClientSearchError('');
            setToDoFliterError('')
            if (!searchUser) {
                setClientSearchError('Please enter valid text'); return;
            }
            setEmployeeListLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchUser }

            //console.log('handleSearchEmployee payload', payLoad);
            // Make the API call
            const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        // setAddEmployeeError('')
                        setEmployeeList(responseData?.dataJ || []);
                        //   setError(responseData?.info);
                        setTimeout(() => {
                            // handleClose();
                            // onValueChange();
                        }, 2000);
                    } else {
                        setError(responseData?.info || 'Failed to fetch data. Please try again.');
                    }
                } else {
                    setError(responseData?.info || 'Something went wrong while processing your request.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Something went wrong while processing your request. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setError(`Something went wrong while processing your request. Please check your network connection and try again.`);
            }
        } finally {
            setEmployeeListLoading(false);
        }

        // onValueChange(teamData);
        // onClose();
    };

    const [searchFile, setSearchFile] = useState('');
const [fileError, setFileError] = useState('');
const [FileIdList, setFileIdList] = useState([]);
const [fileSearchError, setFileSearchError] = useState('');
const [fileListLoading, setFileListLoading] = useState(false)
    const handleSearchFile = async () => {

        try {
            setFileError('');
            setFileSearchError('');
            setToDoFliterError('')
            if (!searchFile) {
                setFileSearchError('Please enter valid text'); return;
            }
            setFileListLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "NAME-FILEID", search_word: searchFile }

            //console.log('handleSearchEmployee payload', payLoad);
            // Make the API call
            const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        // setAddEmployeeError('')
                        setFileIdList(responseData?.dataJ || []);
                        //   setError(responseData?.info);
                        setTimeout(() => {
                            // handleClose();
                            // onValueChange();
                        }, 2000);
                    } else {
                        setFileError(responseData?.info || 'Failed to fetch data. Please try again.');
                    }
                } else {
                    setFileError(responseData?.info || 'Something went wrong while processing your request.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setFileError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setFileError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setFileError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setFileError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setFileError(`Error: ${error.response.status}. ${error.response.data?.message || 'Something went wrong while processing your request. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setFileError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setFileError(`Something went wrong while processing your request. Please check your network connection and try again.`);
            }
        } finally {
            setFileListLoading(false);
        }

        // onValueChange(teamData);
        // onClose();
    };

    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const handleSearchInputChange = (value) => {
        setSearchUser(value);
        if (!value) {
            setSelectedEmployee(null)
        }
    }
    const handleSelectedEmployee = (employee) => {
        setSelectedEmployee(employee);
        setSearchUser(employee?.client_name);

        setEmployeeList([]); // Clear the dropdown
    };

    const [selectedFile, setSelectedFile] = useState(null);
    const handleFileSearchInputChange = (value) => {
        setSearchFile(value);
        if (!value) {
            setSelectedFile(null)
        }
    }
    const handleSelectedFile = (employee) => {
        setSelectedFile(employee);
        setSearchFile(employee?.client_file_id);

        setFileIdList([]); // Clear the dropdown
    };
    const[toDoFilterError, setToDoFliterError] = useState('')
    const fetchActiveToDoItemsFilterList = async () => {
        if(!selectedEmployee?.client_id && !selectedFile?.client_id && !addedDate && !dueDate){
            setToDoFliterError('Please fill at least one field to search');
            return;
          }
            try {
              setToDoFliterError('');
                setActiveToDoLoading(true);
                setActiveToDoError('')
                setActiveToDoList([])
                setClientSearchError('');
                setCurrentPage(1);
                // setTeamInfo({});
                const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
                const payLoad = {
                  action_type: "sc_filter",
                  emp_id_auth: storedUserInfo?.emp_id,
                  client_id: selectedEmployee?.client_id,
                  client_name: searchUser || '',
                  client_file_id: selectedFile?.client_file_id,
                  create_at: addedDate,
                  sc_time: dueDate,
                  sc_list_status: "Active",
                }
                if (source) payLoad.source = source;
                console.log("payLoad in Todo Filter in add ons", payLoad)
                // return
                // Make the API call
                const response = await postData(ORG_TODO_LIST_ADDONS, payLoad);
                const responseData = await response.json();
    
                // Check for success (200) and internal status code
                if (response?.status === 200) {
                    if (responseData?.statusCode === 200) {
                        if (responseData?.message.toLowerCase() === 'success') {
                            if (responseData?.dataJ?.length > 0) {
                                setActiveToDoList(responseData?.dataJ);
                            } else {
                                setActiveToDoError(responseData?.info || 'Data Not Found');
                            }
                        } else {
                            setActiveToDoError(responseData?.info || 'Failed to fetch Team Information. Please try again.');
                        }
                    } else {
                        setActiveToDoError(responseData?.info || 'Failed to fetch Team Information.');
                    }
                }
                // Token-related errors: 400, 401, 403
                else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                    if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                        setActiveToDoError('Unauthorized access. Your session may have expired. Please log in again.');
                        // Optionally, redirect to the login page or refresh the token
                        // Example: redirectToLogin();
                    } else {
                        setActiveToDoError(responseData?.info || 'Bad request. Please check the request parameters.');
                    }
                }
                // Internal Server Error: 500
                else if (response?.status === 500) {
                    setActiveToDoError(responseData?.info || 'Internal Server Error. Please try again later.');
                }
                // Unexpected or network-related errors
                else {
                    setActiveToDoError('Unexpected error occurred. Please try again later.');
                }
            } catch (error) {
                // Handle various error scenarios
                if (error.response) {
                    // Server responded with a status outside the 2xx range
                    setActiveToDoError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Team Information. Please try again.'}`);
                } else if (error.request) {
                    // Request was made but no response was received
                    setActiveToDoError('No response received from the server. Please check your network connection and try again.');
                } else {
                    // An error occurred in setting up the request
                    setActiveToDoError(`Failed to fetch Team Information. Please check your network connection and try again.`);
                }
            } finally {
                setActiveToDoLoading(false);
                showFilter();
            }
        }

        const resetFilter = ()=>{
          setSearchFile('');
          setSearchUser('');
          setAddedDate('');
          setSelectedEmployee(null);
          setDueDate('')
          setToDoFliterError('');
          setClientSearchError('');
          setError('');
          setSelectedFile('')
        }

    return {
        handlePageChange,
        currentToDoActiveItems,
        currentPage,
        totalPages,

        handleCloseDeleteModal,
        handleOpenDeleteModal,
        handleDelete,
        isDeleteModalOpen,
        selectedDocument,
        setSelectedDocument,

        deletedMessages,
        currentActiveToDoDeleteIndex,
        success,
        activeToDoDeleteError,
        loading,
        handleToDoActiveItemDelete,

        clientSearchError,
        employeeList,
        error,
        employeesListLoading,
        handleSelectedEmployee,
        handleSearchInputChange,
        searchUser,
        handleSearchEmployee,
        // setAddedOn,
        // addedOn,
        // setValidFrom,
        // validFrom,
        // setStatus,
        // status,
        fetchActiveToDoItemsFilterList,
        toDoFilterError,
        resetFilter,

        setDueDate,
        dueDate,
        addedDate,
        setAddedDate,

        fileListLoading,
        fileSearchError,
        FileIdList,
        fileError,
        searchFile,
        handleSearchFile,
        selectedFile,
        handleSelectedFile,
        handleFileSearchInputChange
    }

}

export default ToDoListActiveController